/**
 * ErrorStandalone.js
 * @author Huarte Joaquin
 */

//Dependencies
import React, { Component } from 'react';
import { connect } from 'react-redux'
import $ from 'jquery';
import { disableRiesgoNet } from '../../../actions/actions';

//material-ui
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import logoBh from '../../../static/img/logo-bh.png';


//Assets
// import error from '../../../static/img/404.png';
import error from '../../../static/img/face-error.png';
import checked from "../../../static/img/checked.png"

//Services
import { processToken } from './../services/tokenService';
import { processFlow } from './../services/flowService';
import { processIdClientAnalytics } from './../services/pixelService';
import { Layout } from '../layout/Layout';

class ErrorStandAlone extends Component {

    constructor(props) {
        super(props);
        this.state = { }   
    }

    componentWillMount() {
        if (this.props.riesgoNetEnabled) {
            this.props.dispatch(
                disableRiesgoNet()
            );
        } else {
            this.validateFlow();
        }
        this.validateToken();
        processIdClientAnalytics('error');
    }

    componentDidMount() {
        $(".load").fadeOut(700);
    }

    validateFlow() {
        processFlow(this.props.history, this.state.paso);
    }

    validateToken() {
        processToken(this.props.history);
    }

    render() {
        const footer = {
            button: {
                link: 'https://buhobank.com/buhobank/tarjetas',
                text : "reintentar"
            }
        };
        const body = { img : { src : error } }
        return (
            <Layout footer={footer} body={body}
                tieneFooter>
                <Grid container 
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Grid item xs={12} >
                        <div className="content-description">
                            <h5 className="title" >No podemos validar tu identidad digitalmente</h5>
                            <div className="description-sa">Por favor, vuelva a intentarlo en otro momento.</div>
                            <div className="centerText">Acordate de: </div>

                            <li className="listado"><img src={require('../../../static/img/checked.png')} className="checkedImage" alt="" /> <span className="tipText">Tener tu ejemplar de DNI a mano</span> </li>
                            <li className="listado"><img src={require('../../../static/img/checked.png')} className="checkedImage" alt="" /> <span className="tipText">Buscar una habitación iluminada asi no sale oscura la foto</span> </li>
                            <li className="listado"><img src={require('../../../static/img/checked.png')} className="checkedImage" alt="" /> <span className="tipText">No usar gorro ni lentes</span> </li>
                        </div>
                    </Grid>
                </Grid>
            </Layout>
            
        );
    }
}

const mapStateToProps = function (state) {
    return {
        riesgoURLNet: state.riesgoURLNet.url,
        riesgoNetEnabled: state.riesgoNetEnabler.enable,
        flujo: state.navigation.flujo,
        paso: state.navigation.paso,
        token: state.token.id
    }
}

export default connect(mapStateToProps)(ErrorStandAlone);


// WEBPACK FOOTER //
// ./src/components/OnBoarding/error/ErrorStandAlone.js